import "./MainPanel.scss";
import {Link} from "react-router-dom";
import React, {useEffect, useState} from "react";
import SidebarResponsive from "./SidebarResponsive";
import axios from "axios";
import { prefixUrl } from "../../Utils/utilsData";
import { toast } from "react-toastify";
import numeric from '../../Utils/NumericFunction'
import {formatToPersianAddComma} from "../../Utils/CommaSeparator";
const Header = ({title, open, setOpen}) => {

  const [name, setName] = useState("")
  const [balance, setBalance] = useState(0)
  const myName = localStorage.getItem("name")

  useEffect(() => {
    setName(localStorage.getItem("name"));
  }, [myName]);

  // Update Wallet Balance
  useEffect(() => {
    axios.get(`${prefixUrl()}/user/walletRemaining.php`)
    .then(res => setBalance(res.data.data))
    .catch((error) => {
      toast.error("خطا در بر قراری ارتباط")
      console.error("Error sending GET request:", error)
    })
  }, []);

  return (
    <>
      <SidebarResponsive open={open} setOpen={setOpen}/>
      <div className="panel-header">
        <div className="panel-header-border">
          {/* title */}
          <div className="panel-header-title">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="13"
              height="14"
              viewBox="0 0 13 14"
              fill="none"
            >
              <path
                d="M1 8.63977C-0.333331 7.86997 -0.333334 5.94546 0.999999 5.17566L9.25 0.412526C10.5833 -0.357276 12.25 0.604973 12.25 2.14457L12.25 11.6709C12.25 13.2105 10.5833 14.1727 9.25 13.4029L1 8.63977Z"
                fill="#EE6900"
              />
            </svg>

            {title}
          </div>

          {/* menu */}
          <div className="burger-menu" open={open} onClick={() => setOpen(!open)}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M21 7.75H3C2.59 7.75 2.25 7.41 2.25 7C2.25 6.59 2.59 6.25 3 6.25H21C21.41 6.25 21.75 6.59 21.75 7C21.75 7.41 21.41 7.75 21 7.75Z"
                fill="#EE6900"
              />
              <path
                d="M21 12.75H3C2.59 12.75 2.25 12.41 2.25 12C2.25 11.59 2.59 11.25 3 11.25H21C21.41 11.25 21.75 11.59 21.75 12C21.75 12.41 21.41 12.75 21 12.75Z"
                fill="#EE6900"
              />
              <path
                d="M21 17.75H3C2.59 17.75 2.25 17.41 2.25 17C2.25 16.59 2.59 16.25 3 16.25H21C21.41 16.25 21.75 16.59 21.75 17C21.75 17.41 21.41 17.75 21 17.75Z"
                fill="#EE6900"
              />
            </svg>
          </div>

          {/* wallet balance */}
          <div className="balance text-style">
            <span>موجودی کیف پول :</span>
            <span>{formatToPersianAddComma(balance)} ریال</span>
          </div>

          {/* username */}
          <div className="left-header text-style">
            <div className="name">
              <span>{name} عزیز خوش آمدید</span>
            </div>
            <Link to={"/"}>فروشگاه</Link>
          </div>

        </div>
      </div>
    </>
  );
};

export default Header;
